import { PayloadAction } from "@reduxjs/toolkit";
import { MarkupRule, StockPublicationSliceState } from "../../types";

export const markupReducers = {
  addMarkupRule: (
    state: StockPublicationSliceState,
    action: PayloadAction<MarkupRule>,
  ) => {
    if (state.draftSettings) {
      state.draftSettings.markups.push(action.payload);
    }
  },
  removeMarkupRule: (
    state: StockPublicationSliceState,
    action: PayloadAction<string>,
  ) => {
    if (state.draftSettings) {
      state.draftSettings.markups = state.draftSettings.markups.filter(
        (rule) => rule.id !== action.payload,
      );
    }
  },
};
